import { Button } from '@cian/ui-kit/button';
import classNames from 'classnames';
import * as React from 'react';

import { IRosbankBannerComponentProps } from '../../../types/rosbankBanners';
import * as styles from './styles.css';

export const RosbankPilotBannerSaleOld: React.FC<IRosbankBannerComponentProps> = ({ url, onClick }) => {
  return (
    <div className={styles['container']} data-testid="rosbank-pilot-banner-saleold">
      <a
        className={classNames(styles['wrapper'], styles['flatold'])}
        href={url}
        rel="noreferrer"
        onClick={onClick}
        data-testid="rosbank-pilot-banner-inner-wrapper"
      >
        <div className={styles['title']}>Продавайте старую квартиру уже из новой</div>
        <div className={styles['subtitle']}>Переезжайте и спокойно продавайте хоть два года</div>
        <div>
          <Button size="M" theme="fill_primary">
            Как это возможно
          </Button>
        </div>
      </a>
    </div>
  );
};
